export default __webpack_public_path__ + "static/media/yapp_loading.4d394689.gif";